export default ({ get, post, checkStatus, toJSON }) => ({
  getGameDetails: (id) =>
    get(`universe/v1/games/${id}`).then(checkStatus).then(toJSON),
  getGameState: (classroomId, gameId) =>
    get(`api/v2/game_state/${gameId}?classroom_id=${classroomId}`)
      .then(checkStatus)
      .then(toJSON),
  saveGameState: (gameId, body) =>
    post(`api/v2/game_state/${gameId}/save`, { body })
      .then(checkStatus)
      .then(toJSON),
});
